import Select from "react-select";
import type { MultiValueGenericProps } from "react-select";
import type { DataSourceOption } from "./types";
import { NetworkSelectOptionComponent } from "./NetworkSelectOption";
import { toNetworkSelectOptions } from "./networkSelect.utils";
import type { NetworkSelectOption } from "./networkSelect.utils";
import "./NetworkSelect.scss";

interface NetworkSelectProps {
	options: DataSourceOption[];
	value: string[];
	onChange: (keys: string[]) => void;
	placeholder?: string;
	disabled?: boolean;
	logoBasePath?: string;
}

function NetworkMultiValue({ data, getValue }: MultiValueGenericProps<NetworkSelectOption, true>) {
	const allSelected = getValue();
	const index = allSelected.findIndex((o) => o.value === data.value);
	const isLast = index === allSelected.length - 1;
	return <span className="network-select__value-label">{data.label}{isLast ? "" : ", "}</span>;
}

export function NetworkSelect({ options, value, onChange, placeholder, disabled, logoBasePath }: NetworkSelectProps) {
	const selectOptions = toNetworkSelectOptions(options);
	const selectedOptions = selectOptions.filter((o) => value.includes(o.value));

	return (
		<Select<NetworkSelectOption, true>
			isMulti
			closeMenuOnSelect={false}
			hideSelectedOptions={false}
			isDisabled={disabled}
			isOptionDisabled={(opt) => !opt.isSelectable}
			placeholder={placeholder}
			options={selectOptions}
			value={selectedOptions}
			onChange={(selected) => onChange(selected.map((o) => o.value))}
			getOptionValue={(opt) => opt.value}
			getOptionLabel={(opt) => opt.label}
			menuPortalTarget={document.body}
			classNamePrefix="network-select"
			styles={{
				menuPortal: (base) => ({ ...base, zIndex: 10200 }),
			}}
			components={{
				Option: (props) => <NetworkSelectOptionComponent {...props} logoBasePath={logoBasePath} />,
				MultiValue: NetworkMultiValue,
				MultiValueRemove: () => null,
			}}
		/>
	);
}
